import App from './index/components/AppV2.vue';
import Vue from 'vue';
import vueIntersectionPlugin from 'root/common/util/vueIntersection';
import bigTj from 'root/common/util/Stat';
import './index.view.scss';
import '@/common/util/loading-fix';
import MpDownloadAppDirective from '@/common/directives/mp-download-app';
import { gioEvariableTrackOfPrivilege } from 'root/common/gio/tqGio';
import env from '@/common/util/env';
import { getAppVersion, compareVersion } from 'root/common/util/getAppVersion';
import { getUtmParams } from '@/common/gio/utm';

// 曝光模块，单页统一处理
Vue.use(vueIntersectionPlugin, {
    handler: logData => {
        if (logData) {
            if (logData.gio) {
                gioEvariableTrackOfPrivilege('rechargeSkuView', {
                    data: { ...JSON.parse(logData.gio), ...getUtmParams(false) },
                });
                if (logData.tj && bigTj) {
                    bigTj.track('show', JSON.parse(logData.tj));
                }
                return;
            }
            if (logData.gioAction && logData.gioActionData) {
                gioEvariableTrackOfPrivilege(logData.gioAction, {
                    data: logData.gioActionData,
                });
                delete logData.gioAction;
                delete logData.gioActionData;
            }
            if (bigTj) {
                bigTj.track('show', logData);
            }
        }
    },
    duration: 1000, //在页面可视区域停留时长
});
Vue.config.errorHandler = err => {
    // handle error
    console.error(err);
    err = err || { stack: '' };
    if (window.monitor) {
        window.monitor.report({
            level: 'error',
            error: 'js',
            url: window.location.href,
            msg: `vueCaptureError --> ${err.message}`,
            stack: err.stack.slice(0, 300),
        });
    }
};
Vue.prototype.$toast = window.ZZCFL.Toast;
Vue.prototype.$alert = window.ZZCFL.Dialog;
Vue.prototype.$loading = window.ZZCFL.Loading;

Vue.use(MpDownloadAppDirective);

const vm = new Vue({
    render: h => h(App),
});

const findString = (string, search) => {
    return string.toLowerCase().indexOf(search.toLowerCase()) > -1;
};

const href = location.href;
const isNewUi = findString(href, 'topbar_remove') || findString(href, 'isNew');

if (env.isApp && !isNewUi) {
    if (env.isAndroid) {
        if (compareVersion(getAppVersion(), '2.17.2') >= 0) {
            setTimeout(() => {
                window.zzc.call('change_appbar_state', {
                    show: false, // true 显示标题栏， false隐藏标题栏
                    success: () => {},
                });
            }, 300);
        } else {
            const currentHref = location.href;
            setTimeout(() => {
                window.zzc.call('base_destroyPage', {
                    urls: [currentHref], // url 集合
                    success: function() {},
                });
                location.href = `${location.origin}/new/tqcz/index.html?${location.search.substring(
                    1
                )}&ZZCAppArg=appopenpage,topbar_remove`;
            }, 300);
        }
    } else if (env.isIos) {
        if (env.isAppVest) {
            setTimeout(() => {
                window.location.replace(
                    `${location.origin}/new/tqcz/index.html?${location.search.substring(
                        1
                    )}&ZZCAppArg=selfopenpage,topbar_remove`
                );
            }, 300);
        } else {
            setTimeout(() => {
                window.zzc.call('base_showNavigationBar', {
                    show: 0, // 1：显示导航栏， 0：隐藏标题栏
                    success: function() {},
                });
            }, 500);
        }
    }
}

vm.$mount('#app');

window._vue = vm;
export default vm;
